"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get getGlobalInputHashFilePath () {
        return getGlobalInputHashFilePath;
    },
    get getHashFilePath () {
        return getHashFilePath;
    }
});
const _path = /*#__PURE__*/ _interop_require_default(require("path"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function getHashFilePath(target) {
    return _path.default.join(`node_modules/.lage/hash_${target.task}`);
}
function getGlobalInputHashFilePath(target) {
    return _path.default.join(`node_modules/.lage/global_inputs_hash_${target.task}`);
}
